module.exports = __webpack_public_path__ + "200420db9646dfe9fe16589ceb348baf.svg";